module.exports = __webpack_public_path__ + "img/index-book-image.710b2229.png";